
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignStairsRight as ObiSignStairsRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-stairs-right.js';
 
 
 

 
 export const ObiSignStairsRight = createComponent({
   react: React,
   tagName: 'obi-sign-stairs-right',
   elementClass: ObiSignStairsRightElement,
   events: {
     
   }
  });
 
 